import React from 'react';
import { CheckCircleIcon, UserIcon } from 'lucide-react';
interface TestimonialCardRlt2Props {
  name: string;
  location: string;
  duration: string;
  testimonial: string;
}
const TestimonialCardRlt2 = ({
  name,
  location,
  duration,
  testimonial
}: TestimonialCardRlt2Props) => {
  return <div className="border-l-2 border-gray-800 pl-5 py-4 my-6 bg-gray-50 rounded-r shadow-sm" data-id="element-6353">
      <blockquote className="font-serif text-gray-700 italic mb-4 leading-relaxed text-base" data-id="element-6354">
        "{testimonial}"
      </blockquote>
      <div className="flex items-center border-t border-gray-200 pt-3" data-id="element-6355">
        <div className="w-6 h-6 rounded-full bg-gray-300 flex items-center justify-center mr-2" data-id="element-6356">
          <UserIcon className="h-3 w-3 text-gray-600" data-id="element-6357" />
        </div>
        <div className="text-sm text-gray-600" data-id="element-6358">
          <span className="font-medium text-gray-800" data-id="element-6359">{name}</span>
          <span className="mx-1" data-id="element-6360">•</span>
          <span data-id="element-6361">{location}</span>
          <span className="mx-1" data-id="element-6362">•</span>
          <span data-id="element-6363">Using product for {duration}</span>
        </div>
        <div className="ml-2 flex items-center text-green-600 text-xs font-medium border border-green-200 rounded-full px-2 py-0.5 bg-green-50" data-id="element-6364">
          <CheckCircleIcon className="h-3 w-3 mr-1" data-id="element-6365" />
          <span data-id="element-6366">Verified</span>
        </div>
      </div>
    </div>;
};
export default TestimonialCardRlt2;